import commonApi from './CommonApi.js';

export default {
   
    generate: async (parameters) => {
        return await commonApi().get('/documents/generate', { params: parameters, responseType: 'blob' })
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
}
